<template lang="pug">
    div
        Button(icon="md-help" size="large" shape="circle" @click="isExampleModalShown=true")
        Modal(v-model="isExampleModalShown" :title="$t(`objectExplanation.title`)" footer-hide)
            List
                ListItem(v-for="(item,key) in objectExplanationItems" :key="key" :name="item.name" v-if="objectExplanation[item.value] !== ''")
                    ListItemMeta(:title="$t(`objectExplanation.${item.value}`)" :description="objectExplanation[item.value]")
</template>
<script>
export default {
    name: "ExplainBtn",
    props: { objectExplanation: { type: Object, default: {} } },
    data() {
        return {
            isExampleModalShown: false,
            objectExplanationItems: [
                { name: "功能", value: "usage" },
                { name: "組成要件", value: "constituent" },
                { name: "範例情境", value: "scenarios" },
                { name: "範例", value: "example" }
            ]
        };
    }
};
</script>


// WEBPACK FOOTER //
// src/components/ExplainBtn.vue